import { FC, SVGAttributes } from 'react';

const Loyalty: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.37978 2.5C6.19923 2.5 5.24219 3.45704 5.24219 4.63759V10.3378C5.24219 14.0695 8.26729 17.0946 11.9989 17.0946C15.7306 17.0946 18.7557 14.0695 18.7557 10.3378V4.63759C18.7557 3.45704 17.7986 2.5 16.6181 2.5H7.37978Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M12 17.9055V18.9866"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M15.2441 19.7974H8.7576C8.01127 19.7974 7.40625 20.4024 7.40625 21.1487C7.40625 21.895 8.01127 22.5001 8.7576 22.5001H15.2441C15.9904 22.5001 16.5954 21.895 16.5954 21.1487C16.5954 20.4024 15.9904 19.7974 15.2441 19.7974Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M4.97223 4.93237C3.47957 4.93237 2.26953 6.14242 2.26953 7.63508V7.99014C2.26953 8.8011 2.59168 9.57885 3.16513 10.1523L5.51277 12.4999"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.0249 4.93237C20.5176 4.93237 21.7276 6.14242 21.7276 7.63508V7.99014C21.7276 8.8011 21.4055 9.57885 20.8321 10.1523L18.4844 12.4999"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Loyalty;
